import { JsonQuery } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

export const apartments: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = new JsonQuery(jsonQuery).getApartments();
    if (value == null) {
      return null;
    }

    return [
      {
        group: 'apartments',
        text: value ? 'Только апартаменты' : 'Без апартаментов',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setApartments',
      arguments: [null],
    });
  },
};
